import {StorageController} from "mobx-persist-store/lib/esm2017/types";

class InMemoryStorageAdapter implements StorageController {

    private inMemoryStorage: { [key: string]: string } = {};
    private getStorage: () => Storage;

    constructor(getStorage: () => Storage) {
        this.getStorage = getStorage;
    }

    public getItem = (name: string) => {
        if (this.inMemoryStorage.hasOwnProperty(name)) {
            return this.inMemoryStorage[name];
        }
        return this.getStorage().getItem(name);
    }

    public removeItem = (name: string) => {
        try {
            this.getStorage().removeItem(name);
        } catch (ignore) {
            debugger
        }
        delete this.inMemoryStorage[name];
    }

    public setItem = (name: string, value: string) => {
        try {
            this.getStorage().setItem(name, value);
        } catch (ignore) {
            debugger
        }
        this.inMemoryStorage[name] = String(value); // not everyone uses TypeScript
    }
}

function storageFactory(getStorage: () => Storage): StorageController {
    return new InMemoryStorageAdapter(getStorage);
}

export const localStore = storageFactory(() => localStorage)
export const sessionStore = storageFactory(() => sessionStorage)